import script from "./LnventoryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./LnventoryManagement.vue?vue&type=script&setup=true&lang=js"

import "./LnventoryManagement.vue?vue&type=style&index=0&id=58f103fc&lang=css"

const __exports__ = script;

export default __exports__